'use client';

import { RefObject, useCallback, useEffect, useState } from 'react';
import { observeElementSize } from 'src/components/primitives/Table/observeElementSize';

export function useHasHorizontalOverflow(
	containerRef: RefObject<HTMLElement | null>
): boolean {
	const [hasOverflow, setHasOverflow] = useState(false);

	const updateOverflowState = useCallback(() => {
		const container = containerRef.current;
		if (!container) return;

		const { scrollWidth, clientWidth } = container;
		const newHasOverflow = scrollWidth > clientWidth;

		setHasOverflow((prev) => (prev === newHasOverflow ? prev : newHasOverflow));
	}, [containerRef]);

	useEffect(() => {
		const container = containerRef.current;
		if (!container) return;

		updateOverflowState();

		return observeElementSize(container, updateOverflowState);
	}, [containerRef, updateOverflowState]);

	return hasOverflow;
}
